var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import shortId from 'shortid';
import { Loggeable } from '../common/loggeable.cls';
var Process = /** @class */ (function (_super) {
    __extends(Process, _super);
    function Process(iProvider) {
        var _this = _super.call(this) || this;
        /**
         * @Override
         * settings for this process
         */
        _this.settings = {};
        _this.iProvider = iProvider;
        _this.settings.pid = _this.generateProcessId();
        return _this;
    }
    /**
     * generate a unique process id fpr classes
     * implementing the IProcess interface
     * @see IProcess
     */
    Process.prototype.generateProcessId = function () {
        return shortId.generate();
    };
    return Process;
}(Loggeable));
export { Process };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/lib/process/process.cls.ts
// module id = null
// module chunks = 